import React from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import titleConfig from './titleConfig';

const TitleManager = () => {
    const location = useLocation();
    
    const getTitle = (pathname) => {
      if (titleConfig[pathname]) {
        return titleConfig[pathname];
      }

      if (pathname.includes('/dashboard/orders/')) {
        return 'Order Details - Shippal'; 
      }
    
  
      return "";
    };
  
    const title = getTitle(location.pathname);
  
    return (
      <Helmet>
        <title>{title}</title>
      </Helmet>
    );
  };

export default TitleManager;